export enum Rights {
  RIGHT_MANAGE_COMPANIES = 'manageCompanies',
  RIGHT_MANAGE_INVENTORY = 'manageInventory',
  MANAGE_POLICIES_READ = 'managePoliciesRead',
  MANAGE_POLICIES_WRITE = 'managePoliciesWrite',
  RIGHT_MANAGE_USERS = 'manageUsers',
  RIGHT_MANAGE_REPORTS = 'manageReports',
  RIGHT_MANAGE_PLATFORM = 'managePlatform',
  RIGHT_COMPANY_MANAGER = 'companyManager',
  RIGHT_MANAGE_MSP_TRIAL_FEATURES = 'manageMspTrialFeatures',
}
